import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

export const useVehicleMarkList = () => {
  const [vehicleMarkListLoading, setVehicleMarkListLoading] = useState(false);
  const [vehicleMarkList, setVehicleMarkList] = useState([]);

  const getVehicleMarkList = useCallback(async () => {
    setVehicleMarkListLoading(true);
    let res = await request({
      path: "vehicle-stock/list",
    });
    res = res?.data;

    let vehicleList = await request({
      path: "vehicle/list",
    });
    vehicleList = vehicleList?.data;

    //@ts-ignore
    res = vehicleList?.filter((c) => {
      //@ts-ignore
      if (res.find((l) => l.vehicle_id == c.id)) {
        return true;
      }
      return false;
    });

    console.log("filtered list", res);

    //@ts-ignore
    setVehicleMarkList(res);
    setVehicleMarkListLoading(false);
    return res?.data;
  }, []);

  useEffect(() => {
    getVehicleMarkList();
  }, []);

  return { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList };
};
